import gql from 'graphql-tag';

const query = gql`
  query ShoppingListPeriodQuery {
    me {
      id
      shoppingList {
        period {
          start
          end
        }
      }
    }
  }
`;

export default query;
